import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import ContainedButton from '../../../shared/buttons/ContainedButton';
import TextButton from '../../../shared/buttons/TextButton';
import InstructionMessage from '../../../shared/instructionmessage/InstructionMessage.js';
import Close from '@material-ui/icons/CloseOutlined';

const useStyles = makeStyles(theme => ({
    dialogContent: {
        paddingTop: theme.spacing(2)
    },
    tableWrapper: {
        marginBottom: theme.spacing(3)
    }
}));

export default function DialogVisualizarPendencias(props) {
    const { open, onClose, pendingDocs = [], memberName = '', onInsertPendingDoc } = props;
    const classes = useStyles();

    const columnsPendentes = [
        { label: 'Tipo Documento', field: 'documento.nome' },
        { label: 'Descrição da Pendência', field: 'descricao' },
        {
            label: 'Ações',
            cardAction: true,
            filterable: false,
            sortable: false,
            valueGetter: (val, row) => (
                <ContainedButton
                    size="small"
                    onClick={() => onInsertPendingDoc(row)}
                >
                    Inserir Documento
                </ContainedButton>
            )
        }
    ];

    return (
        <Dialog
            open={open}
            scroll="body"
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Documentos Pendentes{memberName ? ` - ${memberName}` : ''}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <InstructionMessage
                    title="Orientações sobre Documentos Pendentes"
                    type="info"
                    variant="standard"
                    collapsible={true}
                    defaultExpanded={true}
                    items={[
                        "Confira o tipo de documento e a descrição de cada pendência deste integrante.",
                        "Clique em Inserir Documento para enviar uma versão atualizada."
                    ]}
                />
                <div className={classes.tableWrapper}>
                    <DataGrid
                        responsive="card"
                        tableContainerProps={{
                            component: 'div'
                        }}
                        rows={pendingDocs}
                        columns={columnsPendentes}
                        comparatorKeys={['documento.nome', 'descricao']}
                        paginate
                        paginateOptions={{
                            rowsPerPage: 5,
                            startPage: 0,
                            resetPageOnRowsChange: true
                        }}
                        noRecordsText="Nenhuma pendência encontrada."
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose} startIcon={<Close />}>
                    Fechar
                </TextButton>
            </DialogActions>
        </Dialog>
    );
}

DialogVisualizarPendencias.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    pendingDocs: PropTypes.array,
    memberName: PropTypes.string,
    onInsertPendingDoc: PropTypes.func.isRequired
};
